export default __webpack_public_path__ + "static/media/telegram.7b96cc81.webp";